import apiFetch from '../apiFetch'

export default function (processingAgencyId, token) {
  return apiFetch({ endPoint: 'GetUsersProcessingAgency/' + processingAgencyId, method: 'GET', token: token })
}
